import { CountUp } from 'countup.js';
import gsap from "gsap";
import { Flip } from "gsap/Flip";
import Lenis from 'lenis'
import ScrollTrigger from "gsap/ScrollTrigger";
import 'lenis/dist/lenis.css'
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

gsap.registerPlugin(ScrollTrigger, Flip);

frappe.ready(() => {
	const is_touch = matchMedia("(pointer: coarse)").matches;
	const is_desktop = () => window.innerWidth > 992;

	const stack_cards_wrapper = document.querySelector(".stack-cards-wrapper");

	if (stack_cards_wrapper) {
		const stack_cards = stack_cards_wrapper.querySelectorAll(".stack-card");
		const our_section = document.querySelector(".our-process-section .our");
		const process_section = document.querySelector(".our-process-section .process");

		let is_spread = false;
		let is_animating = false;

		const elements = [our_section, process_section, ...stack_cards];

		const spread_cards = () => {
			if (is_spread || is_animating) return;

			is_animating = true;

			const state = Flip.getState(elements);

			our_section.style.position = "absolute";
			process_section.style.position = "absolute";

			our_section.style.top = "50%";
			process_section.style.top = "50%";

			our_section.style.transform = "translate(-350%, -50%)";
			process_section.style.transform = "translate(350%, -50%)";

			stack_cards.forEach(card => {
				card.style.position = "relative";
				card.style.transform = "rotate(0deg)";
			});

			Flip.from(state, {
				duration: 0.8,
				ease: "power2.inOut",
				stagger: 0.04,
				absolute: true,
				onStart: () => {
					stack_cards_wrapper.classList.add("is-spread");
				},
				onComplete: () => {
					is_spread = true;
					is_animating = false;
				}
			});
		};

		const collapse_cards = () => {
			if (!is_spread || is_animating) return;

			is_animating = true;

			const state = Flip.getState(elements);

			our_section.style.position = "relative";
			process_section.style.position = "relative";

			our_section.style.transform = "translate(0, 0)";
			process_section.style.transform = "translate(0, 0)";

			stack_cards.forEach((card, index) => {
				card.style.position = "absolute";

				switch (index) {
					case 0: card.style.transform = "rotate(0deg)"; break;
					case 1: card.style.transform = "rotate(15deg)"; break;
					case 2: card.style.transform = "rotate(-25deg)"; break;
					case 3: card.style.transform = "rotate(-10deg)"; break;
				}
			});

			Flip.from(state, {
				duration: 0.8,
				ease: "power2.inOut",
				stagger: 0.04,
				absolute: true,
				onComplete: () => {
					stack_cards_wrapper.classList.remove("is-spread");
					is_spread = false;
					is_animating = false;
				}
			});
		};

		if (is_touch) {
			stack_cards_wrapper.addEventListener("click", (e) => {
				e.stopPropagation();
				spread_cards();
			});

			document.body.addEventListener("click", (e) => {
				if (!stack_cards_wrapper.contains(e.target)) {
					collapse_cards();
				}
			});
		} else {
			stack_cards_wrapper.addEventListener("pointerenter", spread_cards);
			stack_cards_wrapper.addEventListener("pointerleave", collapse_cards);
		}
	}

	const init_swiper = (selector, config) => {
		const el = document.querySelector(selector);
		if (!el) return null;
		return new Swiper(el, config);
	};

	init_swiper(".secured-project-slider", {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 30,
		pagination: {
			el: ".secured-project-pagination",
			clickable: true,
		},
		keyboard: { enabled: true },
		breakpoints: {
			650: { slidesPerView: 2 },
			1205: { slidesPerView: 3 },
			1500: { slidesPerView: "auto" }
		},
		on: {
			init(swiper) { toggle_drag(swiper); },
			resize(swiper) { toggle_drag(swiper); }
		}
	});

	function toggle_drag(swiper) {
		if (!swiper) return;

		const total_slides = swiper.slides.length;

		const visible = swiper.params.slidesPerView === "auto"
			? swiper.slidesPerViewDynamic()
			: swiper.params.slidesPerView;

		swiper.allowTouchMove = total_slides > visible;

		if (swiper.pagination && swiper.pagination.el) {
			if (total_slides > visible) {
				swiper.pagination.el.style.display = "flex";
			} else {
				swiper.pagination.el.style.display = "none";
			}
		}
	}

	document.querySelectorAll(".experties-section-small-screen .content-wrapper .content").forEach((el, i) => el.style.setProperty("--i", i));

	init_swiper(".our-projects .project-slider", {
		slidesPerView: 1,
		spaceBetween: 30,
		speed: 800,
		allowTouchMove: true,
		loop: true,
		keyboard: {
			enabled: false
		},
		pagination: {
			el: ".project-pagination",
			clickable: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			1500: {
				slidesPerView: 3,
			}
		},
		on: {
			init: function () {
				updateProjectHeading(this);
			},
			slideChange: function () {
				updateProjectHeading(this);
			}
		}
	});

	function updateProjectHeading(instance) {
		const current_Width = window.innerWidth;

		let active = instance.activeIndex;

		if (current_Width > 1499) {
			if (instance.activeIndex < instance.slides.length - 1) {
				active = instance.activeIndex + 1;
			}
		} else {
			active = instance.activeIndex;
		}
		
		const active_slide = instance.slides[active];

		if (active_slide) {
			const project = active_slide.getAttribute('data-project');

			const heading = document.querySelector('.project-title span');
			if (heading && project) {
				heading.textContent = project;
			}
		}
	}

	const section = document.querySelector('.our-impact');

	if (section && !section.dataset.animated) {
		const observer = new IntersectionObserver((entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && !section.dataset.animated) {
					section.dataset.animated = "true";

					const counters = section.querySelectorAll('.state');

					counters.forEach((el) => {
						const text = el.innerText.trim();
						const numberMatch = text.match(/\d+/);
						const suffixMatch = text.match(/[^0-9]+$/);

						const end_val = numberMatch ? parseInt(numberMatch[0]) : 0;
						const suffix = suffixMatch ? suffixMatch[0] : '';

						const counter = new CountUp(el, end_val, {
							duration: 2,
							useEasing: true,
							easingFn: (t, b, c, d) =>
								c * (1 - Math.pow(2, -10 * t / d)) + b,
							separator: ',',
							suffix: suffix
						});

						if (!counter.error) counter.start();
					});

					obs.unobserve(section);
				}
			});
		}, {
			threshold: 0.4
		});

		observer.observe(section);
	}

	const mm = gsap.matchMedia();

	mm.add("(min-width: 1024px)", () => {
		const containers = gsap.utils.toArray(".experties-section-big-screen .container-2xl");
		const total = containers.length;

		let current_index = 0;
		let is_animating = false;

		const divider_orders = [1, 2, 3];

		if (total > 1) {
			const elements = containers.map(container => ({
				container,
				right: container.querySelector(".row .right"),
				right_content: container.querySelector(".right-column .content"),
				right_image: container.querySelector(".right-column .villa-img"),

				middle: container.querySelector(".row .middle"),
				middle_content: container.querySelector(".middle-column .content"),
				middle_image: container.querySelector(".middle-column .about-img"),

				left_divider: container.querySelector(".divider.left"),
				left_image: container.querySelector(".divider.left .advocate-img")
			}));

			ScrollTrigger.create({
				trigger: ".experties-section-big-screen",
				scroller: "body",
				pin: true,
				start: "top 0%",
				end: () => `+=${total * window.innerHeight}`,
				invalidateOnRefresh: true,
				preventOverlaps: true,
				fastScrollEnd: true,
				snap: {
					snapTo: 1 / (total - 1),
					duration: 0.3,
					ease: "power3.inOut"
				},
				onUpdate: (self) => {
					if (is_animating) return;

					const index = Math.round(self.progress * (total - 1));
					if (index !== current_index) run_step(index);
				}
			});

			function run_step(new_index) {
				if (is_animating || new_index === current_index) return;

				is_animating = true;

				const current = elements[current_index];
				const next = elements[new_index];

				const flip_order = divider_orders[new_index % divider_orders.length];
				gsap.set([
					next.right_content,
					next.right_image,
					next.middle_content,
					next.middle_image,
					next.left_image
				], { willChange: "transform, opacity" });

				if (flip_order == 1) {
					gsap.set(next.left_divider, {order: 1}, 0);
					gsap.set(next.middle, {order: 2}, 0);
					gsap.set(next.right, {order: 3}, 0);
				} if (flip_order == 2) {
					gsap.set(next.left_divider, {order: 2}, 0);
					gsap.set(next.middle, {order: 1}, 0);
					gsap.set(next.right, {order: 3}, 0);
				} if (flip_order == 3) {
					gsap.set(next.left_divider, {order: 3}, 0);
					gsap.set(next.middle, {order: 1}, 0);
					gsap.set(next.right, {order: 2}, 0);
				}

				const state = Flip?.getState([
					next.right_content,
					next.right_image,
					next.middle_content,
					next.middle_image,

					current.right_content,
					current.right_image,
					current.middle_content,
					current.middle_image,
				]);

				current.container.classList.remove("active", "flipped", "order-1", "order-2", "order-3");
				next.container.classList.add("active", "flipped", `order-${flip_order}`);

				const tl = gsap.timeline({
					onComplete: () => {
						current_index = new_index;
						is_animating = false;
					}
				});

				tl.set(current.container, {opacity: 0}, 0);
				tl.set(next.container, {opacity: 1}, 0);
				tl.from(next.left_image, {y: -80}, 0);

				tl.add(
					Flip.from(state, {
						duration: 0.6,
						ease: "power3.inOut",
						overwrite: true
					}), 0
				);
			}
		}

		return () => {
			ScrollTrigger.getAll().forEach(t => t.kill());
		};
	})

	const lenis = new Lenis({
		duration: 1.5
	});

	lenis.on("scroll", ScrollTrigger.update);
	gsap.ticker.add((time) => {
		lenis.raf(time * 1000);
	});

	gsap.ticker.lagSmoothing(0);

	document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
		anchor.addEventListener("click", e => {
			if (anchor.innerText.toLowerCase() == "expertise") return;

			e.preventDefault();

			let href = anchor.getAttribute("href");

			if (href.startsWith("/#")) {
				href = href.substring(1);
			}

			const target = document.querySelector(href);

			if (!target) return;

			lenis.stop();

			setTimeout(() => {
				window.scrollTo({
					top: target.offsetTop,
					behavior: "instant"
				});

				ScrollTrigger.refresh();

				lenis.start();
			}, 50);
		});
	});

	// For Gallery...
	document.querySelectorAll(".see-more").forEach((btn) => {
		btn.addEventListener("click", function () {
			const images = JSON.parse(this.dataset.gallery || "[]");

			if (!images.length) return;

			const start_date = this.dataset.start_date;
			const handover_date = this.dataset.handover_date;
			const type = this.dataset.type;
			const sqrft = this.dataset.sqrft;

			const html = `
				<ul class='project-caption'>
					<li>
						<img src="/assets/aura_website/images/launch.svg" alt="Started Date" />
						<strong>${start_date}</strong>
					</li>
					<li>
						<img src="/assets/aura_website/images/est.svg" alt="Handover Date" />
						<strong>${handover_date}</strong>
					</li>
					<li>
						<img src="/assets/aura_website/images/current.svg" alt="Project Area" />
						<strong>${sqrft}</strong>
					</li>
					<li>
						<img src="/assets/aura_website/images/status.svg" alt="Type" />
						<strong>${type}</strong>
					</li>
				</ul>
			`;

			Fancybox.show(
				images.map((img) => ({
					src: img,
					type: "image",
					caption: html,
				})), {
					Thumbs: {
						autoStart: true,
					},
					Toolbar: {
						display: {
							left: [],
							middle: [],
							right: ["close"],
						},
					},
				}
			);
		});
	});
});